<template>
  <transition name="search-history">
    <div
      v-if="open && items.length"
      class="absolute left-0 right-0 top-[calc(100%+8px)] z-[1201] overflow-hidden rounded-[14px] border border-gray-border bg-white shadow-[0_12px_28px_rgb(0_0_0_/_0.12)]"
    >
      <button
        v-for="item in items"
        :key="item"
        type="button"
        class="flex h-11 w-full min-w-0 items-center gap-3 px-4 text-left text-[14px] font-helvetica-700 text-gray-dark transition-colors hover:bg-white-gray focus:bg-white-gray focus:outline-none active:bg-selected-filter md:h-12 md:text-[15px]"
        :aria-label="`Искать ${item}`"
        @pointerdown.prevent="selectItem(item)"
      >
        <span
          class="relative flex h-5 w-5 shrink-0 items-center justify-center text-extra-text-color"
          aria-hidden="true"
        >
          <svg
            viewBox="0 0 24 24"
            class="h-5 w-5"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              d="M3 12a9 9 0 1 0 3-6.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M3 4v5h5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M12 7v5l3 2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span class="min-w-0 flex-1 truncate">
          {{ item }}
        </span>
      </button>
    </div>
  </transition>
</template>

<script setup lang="ts">
defineProps<{
  items: string[];
  open: boolean;
}>();

const emit = defineEmits<{
  (e: "select", value: string): void;
}>();

const selectItem = (value: string) => {
  emit("select", value);
};
</script>

<style scoped>
.search-history-enter-active,
.search-history-leave-active {
  transition:
    opacity 0.14s ease,
    transform 0.14s ease;
}

.search-history-enter-from,
.search-history-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
